import React, { useEffect, useMemo, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectCards } from 'swiper/modules';
import BetTicket from '../BetTicket';
import { useAssistantIntents } from '../../hooks/useLottoAssistantContext';
import { useTicketStateManagement } from '../../hooks/useTicketStateManagement';
import { ensureTicketIds } from '../../utils/ticketHelpers';
import classes from './BetTicketsContainer.module.scss';

import 'swiper/css';
import 'swiper/css/effect-cards';

const DESKTOP_QUERY = '(min-width: 992px)';

const SWIPER_CARD_CONFIG = {
  effect: 'cards',
  touchStartPreventDefault: false,
  noSwipingClass: 'swiper-no-swiping',
};

const useIsDesktop = () => {
  const [isDesktop, setIsDesktop] = useState(() =>
    typeof window !== 'undefined' ? window.matchMedia(DESKTOP_QUERY).matches : false
  );

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;
    const mql = window.matchMedia(DESKTOP_QUERY);
    const handler = (e) => setIsDesktop(e.matches);
    mql.addEventListener('change', handler);
    return () => mql.removeEventListener('change', handler);
  }, []);

  return isDesktop;
};

const BetTicketsContainer = ({ tickets, isDeleteAllowed = true, messageId, centered = false }) => {
  const isDesktop = useIsDesktop();
  const ticketsWithIds = useMemo(() => ensureTicketIds(tickets), [tickets]);

  const {
    validTickets,
    handleTicketUpdate,
    handleTicketRemove,
    setTicketStates,
  } = useTicketStateManagement({ initialTickets: ticketsWithIds, messageId });

  const { handleBettingOptionsRequest } = useAssistantIntents();

  useEffect(() => {
    setTicketStates(ticketsWithIds);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ticketsWithIds]);

  if (isDesktop) {
    return (
      <div className={`${classes.Grid} ${centered ? classes.GridCentered : ''}`}>
        {validTickets.map((ticket, index) => (
          <BetTicket
            key={ticket.ticket_id}
            ticket={ticket}
            onTicketUpdate={(updatedTicket) => handleTicketUpdate(index, updatedTicket)}
            onRemoveTicket={isDeleteAllowed ? handleTicketRemove : undefined}
            onInfoClick={handleBettingOptionsRequest}
          />
        ))}
      </div>
    );
  }

  return (
    <div className={classes.MobileContainer}>
      <Swiper {...SWIPER_CARD_CONFIG} modules={[EffectCards]}>
        {validTickets.map((ticket, index) => (
          <SwiperSlide key={ticket.ticket_id}>
            <BetTicket
              ticket={ticket}
              onTicketUpdate={(updatedTicket) => handleTicketUpdate(index, updatedTicket)}
              onRemoveTicket={isDeleteAllowed ? handleTicketRemove : undefined}
              onInfoClick={handleBettingOptionsRequest}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default BetTicketsContainer;
